module.exports = __webpack_public_path__ + "img/appBar.0ddd95e5.png";